import React, { useMemo } from 'react';
import styled from 'styled-components';

import { Button, Card, Box } from '@material-ui/core';
import CardIcon from '../../../components/CardIcon';
import Label from '../../../components/Label';
import Value from '../../../components/Value';

import useEarnings from '../../../hooks/useEarnings';
import useHarvest from '../../../hooks/useHarvest';

import { getDisplayBalance } from '../../../utils/formatBalance';
import TokenSymbol from '../../../components/TokenSymbol';
import { Bank } from '../../../tomb-finance';
import useTombStats from '../../../hooks/useTombStats';
import useShareStats from '../../../hooks/usetShareStats';
import CardPyramid from '../../../components/CardPyramid';

interface HarvestProps {
  bank: Bank;
}

const Harvest: React.FC<HarvestProps> = ({ bank }) => {
  const earnings = useEarnings(bank.contract, bank.earnTokenName, bank.poolId);
  const { onReward } = useHarvest(bank);
  const tshareStats = useShareStats();
  // const tShareStats = useShareStats();

  const tokenName = bank.earnTokenName === 'GHOG' ? 'GHOG' : 'HOG';
  // const tokenStats = bank.earnTokenName === 'GHOG' ? tShareStats : tombStats;
  const tokenStats = tshareStats;
  console.log("tokenStats", tokenStats);
  const tokenPriceInDollars = useMemo(
    () => (tokenStats ? Number(tokenStats.priceInDollars).toFixed(2) : null),
    [tokenStats],
  );
  const earnedInDollars = (Number(tokenPriceInDollars) * Number(getDisplayBalance(earnings))).toFixed(2);
  return (
    <Box>
      <div style={{ opacity: "1", willChange: "auto", transform: "none" }}>
        <div style={{ backfaceVisibility: "hidden", transformStyle: "preserve-3d", willChange: "auto", transform: "none" }} tabIndex={0}>
          <div className="relative flex flex-col items-center p-4 rounded-xl border bg-card/60 backdrop-blur text-card-foreground pointer-events-auto transition-all duration-200 hover:shadow-lg group" style={{ minHeight: "320px" }}>
            <StyledCardContentInner>
              <StyledCardHeader>
                <CardIcon>
              <TokenSymbol symbol="GHOG" />
              </CardIcon>
                <Value value={getDisplayBalance(earnings)} />
                <span className="text-m-body text-transparent bg-clip-text bg-gradient-sonic-horizontal">
                  ≈ ${earnedInDollars}
                </span>
                <span className="text-m-body text-transparent bg-clip-text bg-gradient-sonic-horizontal">
                  GHOG Earned
                </span>
              </StyledCardHeader>
          <StyledCardActions>
          <button
                  onClick={onReward}
                  className='tracking-normal inline-flex whitespace-nowrap backdrop-blur items-center justify-center gap-x-1 py-2 px-6 rounded-full font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&>svg]:stroke-[3px] text-button-foreground bg-button/[0.16] hover:bg-button/[0.24] transition focus-visible:ring-button text-body'                  
                  disabled={earnings.eq(0)}
                >
                                Claim
            </button>
          </StyledCardActions>
        </StyledCardContentInner>
        </div>
        </div>
      </div>
      </Box>
  );
};

const StyledCardHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;
const StyledCardActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${(props) => props.theme.spacing[6]}px;
  width: 100%;
`;

const StyledCardContentInner = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export default Harvest;
